<template>
    <div>
        <v-menu :close-on-content-click="false" offset-y v-model="showMenu" max-width="480">
            <template v-slot:activator="{ on }">
                <div v-show="!hasSelection" v-on="on">
                    <v-btn small flat color="secondary" class="ma-0">Select Fields</v-btn>
                </div>
                <v-card ripple hover flat v-show="hasSelection" class="primary white--text">
                    <v-layout row align-center style="cursor: pointer">
                        <v-flex xs12 class="pa-1 pl-2" style="overflow-x: hidden;" v-on="on">
                            <div class="selected-fields-container">
                                <v-chip
                                    v-for="field in selectedFields"
                                    :key="field.id"
                                    small
                                    close
                                    color="white"
                                    text-color="primary"
                                    class="ma-1"
                                    @input="removeField(field.id)"
                                >
                                    {{ field.description }}
                                </v-chip>
                            </div>
                        </v-flex>
                        <v-flex shrink>
                            <v-tooltip top>
                                <v-btn
                                    small
                                    flat
                                    icon
                                    color="white"
                                    class="pa-0 ma-0"
                                    slot="activator"
                                    @click="$emit('input', [])"
                                >
                                    <v-icon>clear_all</v-icon>
                                </v-btn>
                                <span>Clear All</span>
                            </v-tooltip>
                        </v-flex>
                        <v-flex shrink class="pr-1" v-on="on">
                            <v-tooltip top>
                                <v-btn
                                    small
                                    flat
                                    icon
                                    color="white"
                                    class="pa-0 ma-0"
                                    slot="activator"
                                >
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                                <span>Edit Selection</span>
                            </v-tooltip>
                        </v-flex>
                    </v-layout>
                </v-card>
            </template>
            <v-card width="480">
                <v-layout row align-center class="pa-1" style="overflow-x: hidden; overflow-y: auto">
                    <v-flex xs12 style="overflow-x: hidden; overflow-y: auto">
                        <div class="pa-1">
                            <div class="caption greyType--text font-weight-bold">
                                Select Fields
                            </div>
                            <div>
                                <v-text-field
                                    label="Search Workflow Fields"
                                    solo
                                    clearable
                                    prepend-icon="search"
                                    color="primary"
                                    flat
                                    :hide-details="true"
                                    v-model="fieldFilter"
                                    class="pa-0 ma-0"
                                ></v-text-field>
                            </div>
                            <div class="pl-2" style="overflow-x: hidden; overflow-y: auto; max-height: 400px">
                                <div
                                    v-for="(step, i) in stepTree"
                                    :key="i"
                                >
                                    <div class="pa-1 body-2 primary--text">
                                        {{ step.title }}
                                    </div>
                                    <div
                                        v-for="(field, n) in step.fields"
                                        :key="n"
                                        class="body-1 py-1 px-2 ml-2 hover-item greyType--text text--darken-1 field-item"
                                        @click="toggleField(field.id)"
                                    >
                                        <v-layout row align-center>
                                            <v-flex shrink class="pr-2">
                                                <v-icon small :color="isSelected(field.id) ? 'secondary' : 'grey'">
                                                    {{ isSelected(field.id) ? 'check_box' : 'check_box_outline_blank' }}
                                                </v-icon>
                                            </v-flex>
                                            <v-flex xs12>
                                                {{ field.title }}
                                            </v-flex>
                                        </v-layout>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            default: () => []
        },
        steps: Array,
        fields: Array,
        fieldTypeFilter: Array
    },
    data() {
        return {
            showMenu: false,
            fieldFilter: null
        }
    },
    watch: {
        showMenu() {
            this.fieldFilter = null;
        }
    },
    methods: {
        isSelected(fieldId) {
            return Array.isArray(this.value) && this.value.includes(fieldId)
        },
        toggleField(fieldId) {
            const currentValue = Array.isArray(this.value) ? [...this.value] : []
            const index = currentValue.indexOf(fieldId)
            if (index === -1) {
                currentValue.push(fieldId)
            } else {
                currentValue.splice(index, 1)
            }
            this.$emit('input', currentValue)
        },
        removeField(fieldId) {
            const currentValue = Array.isArray(this.value) ? [...this.value] : []
            const index = currentValue.indexOf(fieldId)
            if (index !== -1) {
                currentValue.splice(index, 1)
            }
            this.$emit('input', currentValue)
        }
    },
    computed: {
        hasSelection() {
            return Array.isArray(this.value) && this.value.length > 0
        },
        selectedFields() {
            if (!Array.isArray(this.value)) return []
            return this.value
                .map(id => this.fields.find(field => field.id === id))
                .filter(field => field != null)
        },
        stepTree() {
            return [...this.steps]
                .sort((a, b) => a.field_order - b.field_order)
                .map((step) => {
                    return {
                        title: step.description,
                        id: step.id,
                        fields: [...this.fields]
                            .sort((a, b) => a.field_order - b.field_order)
                            .filter(field => {
                                if (this.fieldTypeFilter && this.fieldTypeFilter.length && !this.fieldTypeFilter.includes(field.fieldType))
                                    return false
                                if (this.fieldFilter && !field.description.toLowerCase().includes(this.fieldFilter.toLowerCase()))
                                    return false
                                return field.fk_step === step.id
                            })
                            .map(field => {
                                return {
                                    title: field.description,
                                    id: field.id
                                }
                            })
                    }
                })
                .filter(step => step.fields.length)
        }
    }
}
</script>

<style scoped>
.selected-fields-container {
    display: flex;
    flex-wrap: wrap;
    max-height: 100px;
    overflow-y: auto;
}

.field-item {
    cursor: pointer;
}
</style>